import { Component, Input, OnInit, TemplateRef, ViewChild, OnChanges } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { PaginationService } from 'src/app/PaginationService';
import { BusinessAreaService } from '../business-area.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { MsalService } from '@azure/msal-angular';
import { messageService } from 'src/app/message.service';

@Component({
  selector: 'app-common-dynamic-button',
  templateUrl: './common-dynamic-button.component.html',
  styleUrls: ['./common-dynamic-button.component.scss']
})
export class CommonDynamicButtonComponent implements OnInit, OnChanges {

  @Input() data: any;

  isProcessing = false;
  rejectReasonList: any;
  isAdenabled: boolean = false;

  visibleConfirmWithReason: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmWithReasonPopup', { static: true }) confirmWithReasonPopup: TemplateRef<any>;

  visibleConfirm: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmPopup', { static: true }) confirmPopup: TemplateRef<any>;

  visibleConfirmWithData: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmWithDataPopup', { static: true }) confirmWithDataPopup: TemplateRef<any>;

  confirmWithReasonPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  confirmPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };
  confirmWithDataPopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  constructor(public dialog: MatDialog, private readonly appService: AppService, private readonly businessAreaService: BusinessAreaService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, private readonly authService: MsalService, public message: messageService) {

  }

  displayUserName: any;
  ngOnInit(): void {
    let userData = JSON.parse(sessionStorage.getItem("userDetails") ?? '{}')
    this.displayUserName = userData.userNameAtApplication;
    this.isAdenabled = localStorage.getItem("adEnabled") == 'Y';
  }

  stageName: any;
  actionStatusOptions: any;
  instructions: any;
  buttonLabels: any = [];
  ngOnChanges() {
    let data: any = {};

    data.executionId = this.data.executionId;
    data.currentStatus = this.data.status;
    this.businessAreaService.getButtonListForExecutionLabels(data).subscribe((response: any) => {
      let buttonList: string[] = [];
      if (response.buttonLabels) {
        buttonList = response.buttonLabels.split(',').map((label: any) => label.trim()).filter((label: any) => label !== '');
      }
      buttonList.push('Cancel')
      this.stageName = response.stageName;
      this.actionStatusOptions = response.actionStatusOptions;
      this.instructions = response.instructions;
      this.buttonLabels = buttonList;
    })
  }

  buttonLabel: any;
  title: any;
  reason: any;
  password: any;
  comments: any;
  userName: any;
  rejectReasonDropdown: any = [];
  reasonDropdown: any = [];
  statusList: any = [];
  selectedReason: any;
  selectedRejectReason: any;
  selectedStatus: any;
  moduleStage: any;
  isEsignRequired = false;
  isReasonSignReqd = false;
  radioValue: any;
  dynamicButtonClick(button: any) {
    this.buttonLabel = button;
    if (button == "Cancel") {
      history.back();
    } else if (button == "Execution Forward") {
      this.title = button;
      this.reason = "";
      this.dropdownToSelectWorkflowStage = [];
      this.selctedForwardWorkflowStage = null;
      this.isProcessing = true;
      this.appService.getWorkflowStageById(this.data.workflowId, this.data.workflowStageId).subscribe((data: any) => {
        this.isProcessing = false;
        if (data) {
          this.dropdownToSelectWorkflowStage = [];
          if (data.nextWorkflowStagesOnSubmitOrApproval != null) {
            let ids = data.nextWorkflowStagesOnSubmitOrApproval.split(",");
            let names = data.nextWorkflowStagesOnSubmitOrApprovalNames.split(",");
            for (let i = 0; i < ids.length; i++) {
              this.dropdownToSelectWorkflowStage = this.dropdownToSelectWorkflowStage.concat({
                valueExp: ids[i],
                displayExp: names[i]
              });
            }
          }
          if (this.dropdownToSelectWorkflowStage.length == 1) {
            this.selctedForwardWorkflowStage = this.dropdownToSelectWorkflowStage[0].valueExp;
          }
        }
      })
      this.visibleConfirmWithReason = this.dialog.open(this.confirmWithReasonPopup, this.confirmWithReasonPopupConfig);
    } else if (button == "Execution Backward") {
      this.title = button;
      this.reason = "";
      this.selctedForwardWorkflowStage = null;
      this.dropdownToSelectWorkflowStage = [];
      this.isProcessing = true;
      this.appService.getWorkflowStageById(this.data.workflowId, this.data.workflowStageId).subscribe((data: any) => {
        this.isProcessing = false;
        if (data) {
          this.dropdownToSelectWorkflowStage = [];
          if (data.nextWorkflowStagesOnRejection != null) {
            let ids = data.nextWorkflowStagesOnRejection.split(",");
            let names = data.nextWorkflowStagesOnRejectionNames.split(",");
            for (let i = 0; i < ids.length; i++) {
              this.dropdownToSelectWorkflowStage = this.dropdownToSelectWorkflowStage.concat({
                valueExp: ids[i],
                displayExp: names[i]
              });
            }
          }
          if (this.dropdownToSelectWorkflowStage.length == 1) {
            this.selctedForwardWorkflowStage = this.dropdownToSelectWorkflowStage[0].valueExp;
          }
        }
      })

      this.visibleConfirmWithReason = this.dialog.open(this.confirmWithReasonPopup, this.confirmWithReasonPopupConfig);
    } else if (button == "Review" || button == "Approve" || button == "Mark As Verification Completed") {
      this.password = "";
      this.comments = "";
      this.rejectReasonDropdown = [];
      this.userName = localStorage.getItem("loggedUserName");
      this.selectedReason = null;
      this.selectedRejectReason = null;
      this.selectedStatus = "";
      this.reasonDropdown = [];
      this.statusList = [];
      let data1 = [];
      if (this.actionStatusOptions != null) {
        data1 = this.actionStatusOptions.split(",");
      }
      for (const element of data1) {
        let data2 = element.split("/");
        if (data2.length > 1) {
          this.statusList.push({ codelistCode: data2[1].trim(), codelistName: data2[0].trim() });
        } else {
          this.statusList.push({ codelistCode: data2[0].trim(), codelistName: data2[0].trim() });
        }

      }
      this.isProcessing = true;
      this.appService.getCodeListsByGroup("BP_REJECT_REASON").subscribe((data: any) => {
        this.rejectReasonList = data;
        this.isProcessing = false;
        for (const element of this.rejectReasonList) {
          this.rejectReasonDropdown = this.rejectReasonDropdown.concat({
            valueExp: element.codelistCode,
            displayExp: element.codelistName
          });
        }
      })
      this.isProcessing = true;
      this.appService.getModuleStages("BP_EXCN", this.stageName)
        .subscribe((data: any) => {
          this.isProcessing = false;

          if (data.length > 0) {
            this.moduleStage = data[0];
            if (data[0].esignReqd == "Y") {
              this.isEsignRequired = true;
            }
            if (data[0].reasonForSignatureReqd == "Y") {
              this.isReasonSignReqd = true;
            }
          }
        })
      this.visibleConfirmWithData = this.dialog.open(this.confirmWithDataPopup, this.confirmWithDataPopupConfig);
    } else {
      this.title = button;
      this.reason = "";
      this.visibleConfirmWithReason = this.dialog.open(this.confirmWithReasonPopup, this.confirmWithReasonPopupConfig);
    }
  }

  dropdownToSelectWorkflowStage: any = [];
  selctedForwardWorkflowStage: any;
  onTypeChanged(value: any) {

  }

  isShowRejectReason = false;
  onStatusSelect(item: any) {
    this.selectedStatus = item;
    this.password = "";
    if (this.selectedStatus.includes("Requested More Info.")) {
      this.isReasonSignReqd = false;
    } else {
      if (this.moduleStage.reasonForSignatureReqd == "Y") {
        this.isReasonSignReqd = true;
      }
      this.statusChanges(this.selectedStatus);
    }

    if (this.rejectReasonList.length > 0 && (this.selectedStatus == 'Review Rejected'
      || this.selectedStatus == 'Approval Rejected' || this.selectedStatus == 'Signoff Rejected')) {
      this.isShowRejectReason = true;
    } else {
      this.isShowRejectReason = false;
    }
  }

  reasonForSignature: any;
  reasonForSignatureList: any;
  statusChanges(status: any) {
    this.reasonDropdown = [];
    this.selectedReason = null;
    this.changetypeAddAndEditPassword = true;
    this.isProcessing = true;
    let data = {
      stageName: this.stageName,
      status: status,
      module: "BP",
    }
    this.appService.getReasonForSigns(data).subscribe((data: any) => {
      this.isProcessing = false;
      this.reasonForSignatureList = data;
      for (const element of this.reasonForSignatureList) {
        this.reasonDropdown = this.reasonDropdown.concat({
          valueExp: element.reasonForSignature,
          displayExp: element.reasonForSignature
        });
      }
      if (this.reasonForSignatureList.length == 1) {
        this.reasonForSignature = this.reasonForSignatureList[0].reasonForSignature;

        this.selectedReason = this.reasonForSignatureList[0].reasonForSignature;
        for (const element of this.reasonDropdown) {
          if (element.valueExp == this.reasonForSignatureList[0].reasonForSignature) {
            this.selectedReason = element.valueExp
          }
        }
      }
    })

  }

  rejectReasonSearchText: string = '';
  reasonSearchText: string = '';
  workflowStageSearchText: string = '';
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  onRejectReasonSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.selectedRejectReason = item?.valueExp ?? null;
    }
  }

  onWorkflowStageSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.selctedForwardWorkflowStage = item?.valueExp ?? null;
    }
  }

  onReasonSelect(event: any, item: any) {

    if (event.isUserInput) {
      this.selectedReason = item?.valueExp ?? null;
    }
  }

  fileExtn: any;
  todayDate = new Date();
  buttonOperationFile: any;
  onConfirmFileSelected(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      this.buttonOperationFile = file;
      this.fileExtn = (file.name.split('.').pop() ?? '').toLowerCase();

      let name = file.name.substring(0, file.name.lastIndexOf('.'));
      const formData = new FormData();
      formData.append('file', file ?? '');
      formData.append("pageName", "BP");
      formData.append("fileName", name);
      formData.append("extension", this.fileExtn);
      this.isProcessing = true;
      this.appService.fileUploadToServer(formData)
        .subscribe({
          next: (data: any) => {
            this.isProcessing = false;
            if (data.resultType == "S") { /* empty */ } else {
              this.buttonOperationFile = null;
              this.fileExtn = '';
              let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: 5000,
                data: {
                  message: data.result,
                  type: data.resultType == 'S' ? 'Success' : 'Error',
                  buttonLabel: "Ok"
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: data.resultType == 'S' ? 'Success' : 'Error',
              });
              sb.onAction().subscribe(() => {
                sb.dismiss();
              });
            }
          }, error: (error) => {

            this.isProcessing = false;
            throw error;
          }
        })


    } else {
      this.buttonOperationFile = '';
      this.fileExtn = '';
    }
  }

  changetypeAddAndEditPassword: boolean = true;
  showPassword() {
    this.changetypeAddAndEditPassword = !this.changetypeAddAndEditPassword;
  }

  status: any;
  pass: any;
  rejectReason1: any;
  reasonForSignature1: any;

  statusRequiredMsg: any;
  passRequiredMsg: any;
  rejectReasonRequiredMsg: any;
  reasonForSignatureRequiredMsg: any;
  buttonOperationFieldValidation() {
    this.status = document.getElementById('status') as HTMLInputElement;
    this.pass = document.getElementById('pass') as HTMLInputElement;
    this.rejectReason1 = document.getElementById('rejectReason') as HTMLInputElement;
    this.reasonForSignature1 = document.getElementById('reasonForSignature') as HTMLInputElement;

    this.statusRequiredMsg = document.getElementById('status-required-msg') as HTMLInputElement;
    this.passRequiredMsg = document.getElementById('pass-required-msg') as HTMLInputElement;
    this.rejectReasonRequiredMsg = document.getElementById('rejectReason-required-msg') as HTMLInputElement;
    this.reasonForSignatureRequiredMsg = document.getElementById('reasonForSignature-required-msg') as HTMLInputElement;


    if (this.selectedStatus == "") {
      this.status.style.border = '1px solid red';
      this.statusRequiredMsg.style.display = 'block';
    } else {
      this.status.style.border = 'none';
      this.statusRequiredMsg.style.display = 'none';
    }
    if (localStorage.getItem("adEnabled") != 'Y') {
      if (this.password == "") {
        this.pass.style.border = '1px solid red';
        this.passRequiredMsg.style.display = 'block';
      } else {
        this.pass.style.border = 'none';
        this.passRequiredMsg.style.display = 'none';
      }
    }
    if (this.rejectReasonList.length > 0 && (this.selectedStatus == "Review Rejected" ||
      this.selectedStatus == "Approval Rejected")) {
      if (this.selectedRejectReason == "") {
        this.rejectReason1.style.border = '1px solid red';
        this.rejectReasonRequiredMsg.style.display = 'block';
      } else {
        this.rejectReason1.style.border = 'none';
        this.rejectReasonRequiredMsg.style.display = 'none';
      }
    }

    if (this.isReasonSignReqd) {
      if (this.selectedReason == "") {
        this.reasonForSignature1.style.border = '1px solid red';
        this.reasonForSignatureRequiredMsg.style.display = 'block';
      } else {
        this.reasonForSignature1.style.border = 'none';
        this.reasonForSignatureRequiredMsg.style.display = 'none';
      }
    }


  }


  confirmWithDataFunc() {
    this.isProcessing = true;
    if (this.isEsignRequired && localStorage.getItem("adEnabled") == 'Y') {
      this.isProcessing = true;
      if (this.selectedStatus == "" || (this.rejectReasonList.length > 0 && (this.selectedStatus == "Review Rejected" ||
        this.selectedStatus == "Approval Rejected") && this.selectedRejectReason == "")) {
        this.buttonOperationFieldValidation();
        this.isProcessing = false;
      } else {
        this.authEnable("reviewAuthenable");

      }
    } else if (this.isEsignRequired) {
      if (this.password == "") {
        this.buttonOperationFieldValidation();
        this.isProcessing = false;
      } else {
        let data = {
          userName: this.userName,
          password: this.password,
        }
        this.isProcessing = true;
        this.appService.validateUser(data).subscribe((data: any) => {
          if (data.resultType == "S") {
            this.isProcessing = true;
            if (this.selectedStatus == "" || (this.rejectReasonList.length > 0 && (this.selectedStatus == "Review Rejected" ||
              this.selectedStatus == "Approval Rejected") && this.selectedRejectReason == "") || (this.isReasonSignReqd && this.selectedReason == "")) {
              this.buttonOperationFieldValidation();
              this.isProcessing = false;
            } else {
              let data = {

                executionId: this.data['executionId'],
                currentStatus: this.data['status'],
                stageName: this.stageName,
                buttonValue: this.buttonLabel,
                actionStatus: this.selectedStatus,
                comments: this.comments,
                rejectReason: this.selectedRejectReason,
                reasonForSignature: this.selectedReason,
                fileExtn: this.fileExtn,
              }
              const formData = new FormData();
              formData.append('file', this.buttonOperationFile);
              const json = JSON.stringify(data);
              const blob = new Blob([json], {
                type: 'application/json'
              });
              formData.append('dto', blob);
              this.performButtonOperationForDocument(formData);
            }
          } else {
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }
        })
      }
    } else {
      this.isProcessing = true;
      if (this.selectedStatus == "" || (this.rejectReasonList.length > 0 && (this.selectedStatus == "Review Rejected" ||
        this.selectedStatus == "Approval Rejected") && this.selectedRejectReason == "")) {
        this.buttonOperationFieldValidation();
        this.isProcessing = false;
      } else {
        let data = {

          executionId: this.data['executionId'],
          currentStatus: this.data['status'],
          stageName: this.stageName,
          buttonValue: this.buttonLabel,
          actionStatus: this.selectedStatus,
          comments: this.comments,
          rejectReason: this.selectedRejectReason,
          reasonForSignature: this.selectedReason,
          fileExtn: this.fileExtn,
        }
        const formData = new FormData();
        formData.append('file', this.buttonOperationFile);
        const json = JSON.stringify(data);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        formData.append('dto', blob);
        this.performButtonOperationForDocument(formData)
      }
    }
    this.isProcessing = false;
  }

  authEnable(flag: string) {

    this.authService.loginPopup({
      scopes: ["User.Read"],
      prompt: "login"
    })
      .subscribe({
        next: (result) => {
          let oldlooginuser = localStorage.getItem("loggedUserName")?.toUpperCase();
          let newuser = result.account?.username.toUpperCase();
          if (oldlooginuser === newuser) {
            if (flag == "reviewAuthenable") {
              let data = {
                executionId: this.data['executionId'],
                currentStatus: this.data['status'],
                stageName: this.stageName,
                buttonValue: this.buttonLabel,
                actionStatus: this.selectedStatus,
                comments: this.comments,
                rejectReason: this.selectedRejectReason,
                reasonForSignature: this.selectedReason,
                fileExtn: this.fileExtn,
              }
              const formData = new FormData();
              formData.append('file', this.buttonOperationFile);
              const json = JSON.stringify(data);
              const blob = new Blob([json], {
                type: 'application/json'
              });
              formData.append('dto', blob);
              this.performButtonOperationForDocument(formData)
            }
            this.isProcessing = false;
          } else {
            this.isProcessing = false;
          }
        },
        error: (error: any) => {
          this.isProcessing = false;
        }
      });
  }

  performButtonOperationForDocument(formData: FormData) {
    this.businessAreaService.getButtonoperationForExecutionLabels(formData).subscribe((Response: any) => {
      this.isProcessing = false;
      if (Response.resultType == "S") {
        this.visibleConfirmWithData.close();
        this.businessAreaService.getExecutionByExecutionId(this.data.executionId).subscribe((response: any) => {
          this.data = response;
          let setUpName = this.message.businessProcess.setUpName;
          this.message.businessProcess = response;
          this.message.businessProcess.setUpName = setUpName;
          this.message.businessProcess.EXECUTION_NO = response.executionNo;
          this.ngOnChanges();
        })

      }
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: Response.result,
          type: Response.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
      this.isProcessing = false;
    })
  }

  cancelConfirmWithDataFunc() {
    this.visibleConfirmWithData.close();
  }

  cancelFunc() {
    this.visibleConfirmWithReason.close();
  }

  deleteReasonValidation() {
    const reason = document.getElementById('reason') as HTMLInputElement;

    const reasonRequiredMsg = document.getElementById('reason-required-msg') as HTMLInputElement;


    if (this.reason == "" || this.reason == null || this.reason == undefined) {
      reason.style.border = '1px solid red';
      reasonRequiredMsg.style.display = 'block';
    } else {
      reason.style.border = 'none';
      reasonRequiredMsg.style.display = 'none';
    }
  }

  confirmWithReasonFunc() {
    this.isProcessing = true;
    if (this.reason == "" || this.reason == null) {
      this.deleteReasonValidation();
      this.isProcessing = false;
    } else if (this.title == "Execution Forward" || this.title == "Execution Backward") {
      let data = {

        executionId: this.data['executionId'],
        currentStatus: this.data['status'],
        fromId: this.data.formId,
        setupId: this.data.setupId,
        stageName: null,
        buttonValue: this.buttonLabel,
        workflowStageId: this.selctedForwardWorkflowStage,
        actionStatus: null,
        comments: this.reason,
        rejectReason: null,
        reasonForSignature: null,

      }
      this.businessAreaService.switchWorkflowStage(data).subscribe((Response: any) => {
        this.isProcessing = false;
        if (Response.resultType == "S") {
          this.visibleConfirmWithReason.close();
          this.businessAreaService.getExecutionByExecutionId(this.data.executionId).subscribe((response: any) => {
            this.data = response;
            let setUpName = this.message.businessProcess.setUpName;
            this.message.businessProcess = response;
            this.message.businessProcess.setUpName = setUpName;
            this.message.businessProcess.EXECUTION_NO = response.executionNo;
            this.ngOnChanges();
            history.back();
          })
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;
      })
    } else {
      this.performCommonOperation();
    }


  }

  performCommonOperation() {
    let data = {
      executionId: this.data['executionId'],
      currentStatus: this.data['status'],
      stageName: null,
      buttonValue: this.buttonLabel,
      actionStatus: null,
      comment: this.reason,
      rejectReason: null,
      reasonForSignature: null,
      fileExtn: null,

    }
    if (this.buttonLabel == "Obsolete") {
      data.stageName = null;
    } else {
      data.stageName = this.stageName;
    }
    //   }
    const formData = new FormData();
    const emptyfile: any = null;
    formData.append('file', emptyfile);
    const json = JSON.stringify(data);
    const blob = new Blob([json], {
      type: 'application/json'
    });
    formData.append('dto', blob);
    this.businessAreaService.getButtonoperationForExecutionLabels(formData).subscribe((Response: any) => {
      this.isProcessing = false;
      if (Response.resultType == "S") {
        this.visibleConfirmWithReason.close();
        this.businessAreaService.getExecutionByExecutionId(this.data.executionId).subscribe((response: any) => {
          this.data = response;
          let setUpName = this.message.businessProcess.setUpName;
          this.message.businessProcess = response;
          this.message.businessProcess.setUpName = setUpName;
          this.message.businessProcess.EXECUTION_NO = response.executionNo;
          this.ngOnChanges();
        })
      }
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: Response.result,
          type: Response.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
      this.isProcessing = false;
    })
  }

}
